import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from '../../AuthContext';
import { Tooltip, Card, CardContent, Typography, Toolbar, Grid, Box, TextField, MenuItem, Select, Skeleton,InputLabel, FormControl, Slider, IconButton, Button, skeleton, Avatar, Stack, Dialog, DialogTitle, DialogContent, DialogActions, } from "@mui/material";
import { useNavigate, Link, useLocation } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';  // Import Star icon for rating
import FilterListIcon from '@mui/icons-material/FilterList'; // Import the filter icon
import VisibilityIcon from '@mui/icons-material/Visibility';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import { AccessTime } from '@mui/icons-material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Import the rupee icon
import Header1 from "../Header/Header1";
import { Masonry } from '@mui/lab';
import Platform from "../Platform/Platform";
import ShareButton from "../Share/ShareButton";
import { formatDateWithSuffix } from '../utils/formatDate';
import { formatTimeToAMPM } from '../utils/formatTime';
import CircularProgress from '@mui/material/CircularProgress';
import Header from "../Header/Header";
import ReserveButton from "../UserReservations/ReserveButton";
import Footer2 from "../Footer/Footer2";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import NeonSpeedometer from "./NeonSpeedometer";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import SearchBar from "./SearchBar";


const API_URL = process.env.REACT_APP_API_URL;



function Posted({ onLogout }) {
  const { userId } = useAuth();
  

  const { role, roles } = useAuth();
const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role];

  const { loggedIn } = useAuth();
  const [showScrollMessage, setShowScrollMessage] = useState(false);
  const location = useLocation();
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  const [sections, setSections] = useState([]);
  const [subsections, setSubsections] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    rating: 0,
    date: "",
    time: "",
    cost: [0, 10000],
    language: "",
    duration: [0, 300],
    sectionId: "",
    subsectionId: "",
  });

  const [page, setPage] = useState(1);
  const [allFetched, setAllFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [tempDate, setTempDate] = useState(filters.date || "");
  const [loadingSeconds, setLoadingSeconds] = useState(0);

  const allowedRoles = ['anthra-sales-executive', 'admin', 'expert'];

  const handleApplyClick = () => {
    handleFilterChange({ target: { value: tempDate } }, "date");
  };
  const [open, setOpen] = useState(true);

  // const handleOpenLink = () => {
  //   window.open(
  //     "https://sites.google.com/anthrasync.com/ai-training-internship-program/home",
  //     "_blank"
  //   );
  // };

  const handleOpenLink = () => {
    navigate("/ai-program-page");
  };

  const handleSkip = () => {
    setOpen(false); // close popup
  };


  useEffect(() => {
    let timer;

    if (loading) {
      setLoadingSeconds(0); // reset timer
      timer = setInterval(() => {
        setLoadingSeconds(prev => prev + 1);
      }, 1000);
    } else {
      clearInterval(timer);
      setLoadingSeconds(0); // optional reset after done
    }

    return () => clearInterval(timer); // cleanup on unmount or loading = false
  }, [loading]);

  const buildQuery = () => {
    let query = `?user_id=${userId}&page=${page}`;

    // if (filters.rating) query += `&rating=${filters.rating}`;
    if (filters.date) query += `&date=${filters.date}`;
    if (filters.time) query += `&time=${filters.time}`;
    if (filters.language) query += `&language=${filters.language}`;
    if (filters.cost) query += `&min_cost=${filters.cost[0]}&max_cost=${filters.cost[1]}`;
    if (filters.duration) query += `&min_duration=${filters.duration[0]}&max_duration=${filters.duration[1]}`;
    if (filters.sectionId) query += `&section_id=${filters.sectionId}`;
    if (filters.subsectionId) query += `&subsection_id=${filters.subsectionId}`;

    return query;
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${API_URL}/list_posted_data/${buildQuery()}`);

      if (response.data.length === 0) {
        setAllFetched(true);
      } else {
        setSections((prevSections) => {
          const newSections = response.data.filter(
            (newSection) => !prevSections.some((section) => section.id === newSection.id)
          );
          return [...prevSections, ...newSections];
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    setPage(1);
    setAllFetched(false);
    setSections([]);
  }, [filters]);

  useEffect(() => {
    if (!allFetched) {
      fetchData();
    }
  }, [filters, userId, page]);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (windowHeight + scrollPosition >= documentHeight - 1 && !loading && !allFetched) {
      setPage((prevPage) => prevPage + 1);
    }
  };


  useEffect(() => {
  let timeout;
  const handleScroll = () => {
    const scrollTop = window.scrollY;

    if (scrollTop > 300 && !loading) {
      setShowScrollMessage(true);
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setShowScrollMessage(false);
      }, 3000); // Hide after 3 seconds
    } else {
      setShowScrollMessage(false);
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => {
    clearTimeout(timeout);
    window.removeEventListener('scroll', handleScroll);
  };
}, [loading]);


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading, allFetched]);

  const extractLanguages = (data) => {
    const allLanguages = new Set();

    data.forEach(item => {
      allLanguages.add(item.name);
    });

    setLanguages([...allLanguages]);
  };


  

  const allCards = sections

  const handleFilterChange = (event, filterType) => {
    setFilters({
      ...filters,
      [filterType]: event.target.value,
    });
  };
  const handleSliderChange = (event, newValue, filterType) => {
    if (Array.isArray(newValue)) {
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    } else {
      // For single value filters
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    }
  };


  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await fetch(`${API_URL}/list_sections_and_subsections/`);
        const data = await response.json();
        const formattedSections = Object.keys(data.sections).map((key) => ({
          section_id: data.sections[key].section_id,
          section_name: key,
          subsections: data.sections[key].subsections || [],
        }));
        setCategories(formattedSections);
        extractLanguages(data.languages);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchSections();
  }, []);


  const handleSearch = (result) => {
    setSections(result)
    // setData(result)
  }

  const handleClearFilters = () => {
    setFilters({
      // rating: 0,
      date: "",
      time: "",
      cost: [0, 500],
      language: "",
      duration: [0, 300],
      sectionId: "",
      subsectionId: "",
    })
    setAllFetched(false);

  }


  const handleSectionChange = (event) => {
    const selectedSectionId = event.target.value;
    setFilters((prev) => ({
      ...prev,
      sectionId: selectedSectionId,
      subsectionId: ''  // Reset subsection when section changes
    }));

    // Find the subsections corresponding to the selected section
    const selectedSection = categories.find(
      (category) => category.section_id === selectedSectionId
    );
    setSubsections(selectedSection ? selectedSection.subsections : []);
  };

  const handleSubsectionChange = (event) => {
    setFilters((prev) => ({
      ...prev,
      subsectionId: event.target.value
    }));
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };


  const handleShare = async (card) => {
    const shareUrl = `${window.location.origin}/post-tab-details/${card.id}`;
    const shareText = card
      ? `Check out this lesson: "${card.highlightedTopic}" by ${card.teacher} ${card.surname}`
      : '';


    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Lesson Highlight',
          text: shareText,
          url: shareUrl,
        });
        setSnackbarMessage('Shared successfully!');
        setSnackbarOpen(true);
      } catch (err) {
        setSnackbarMessage('Share canceled.');
        setSnackbarOpen(true);
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareUrl);
        setSnackbarMessage('Link copied to clipboard!');
        setSnackbarOpen(true);
      } catch (err) {
        setSnackbarMessage('Failed to copy the link.');
        setSnackbarOpen(true);
      }
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div>
    <Box sx={{ padding: "1rem", backgroundColor: "#11111", minHeight: "100vh", mt: -2, ml: { xs: 0, sm: 5 }, }}>
      <Box
        sx={{
          position: 'fixed', // or 'relative' / 'sticky' based on your layout
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300, // higher than MUI drawers (default is 1200)
        }}
      >
 
          <Header1/>
          {/* <Header1 page_name="posted" onSearch={handleSearch}/> */}
      </Box>

      {loggedIn && (
        <Box>
          <Platform />
        </Box>
      )}

      <SearchBar onResults={setSections} />

      

      {loggedIn && (
      <Box position="static" color="primary" sx={{ mt: 3, backgroundColor: '#000000' }}>
        <Toolbar>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 2 }}>
            
            {/* Single Button */}
            <Button
              variant={isActive('/platform/explore') ? 'contained' : 'outlined'}
              color={isActive('/platform/explore') ? 'secondary' : 'inherit'}
              onClick={() => navigate('/platform/explore')}
              sx={{
                borderRadius: '20px',
                textTransform: 'none',
                fontWeight: 'bold',
                px: 3,
                py: 1,
                bgcolor: isActive('/platform/explore') ? 'secondary.main' : 'transparent',
                color: isActive('/platform/explore') ? 'white' : 'inherit',
                border: '2px solid',
                borderColor: isActive('/platform/explore') ? 'primary.main' : 'inherit',
                '&:hover': {
                  bgcolor: isActive('/platform/explore') ? 'secondary.dark' : 'action.hover',
                  borderColor: 'primary.main',
                },
              }}
            >
              Explore
            </Button>
      
            {/* Multiple Button */}
            {allowedRoles.some(r => userRoles.includes(r)) && (
            <Button
              variant={isActive('/platform/my-hosts') ? 'contained' : 'outlined'}
              color={isActive('/platform/my-hosts') ? 'secondary' : 'inherit'}
              onClick={() => navigate('/platform/my-hosts')}
              sx={{
                borderRadius: '20px',
                textTransform: 'none',
                fontWeight: 'bold',
                px: 3,
                py: 1,
                bgcolor: isActive('/platform/my-hosts') ? 'secondary.main' : 'transparent',
                color: isActive('/platform/my-hosts') ? 'white' : 'inherit',
                border: '2px solid',
                borderColor: isActive('/platform/my-hosts') ? 'primary.main' : 'inherit',
                '&:hover': {
                  bgcolor: isActive('/platform/my-hosts') ? 'secondary.dark' : 'action.hover',
                  borderColor: 'primary.main',
                },
              }}
            >
              Hostings
            </Button>
            )}

            <Button
              variant={isActive('/platform/bookings') ? 'contained' : 'outlined'}
              color={isActive('/platform/bookings') ? 'secondary' : 'inherit'}
              onClick={() => navigate('/platform/bookings')}
              sx={{
                borderRadius: '20px',
                textTransform: 'none',
                fontWeight: 'bold',
                px: 3,
                py: 1,
                bgcolor: isActive('/platform/bookings') ? 'secondary.main' : 'transparent',
                color: isActive('/platform/bookings') ? 'white' : 'inherit',
                border: '2px solid',
                borderColor: isActive('/platform/bookings') ? 'primary.main' : 'inherit',
                '&:hover': {
                  bgcolor: isActive('/platform/bookings') ? 'secondary.dark' : 'action.hover',
                  borderColor: 'primary.main',
                },
              }}
            >
              Bookings
            </Button>
      
          </Box>
        </Toolbar>
      </Box>
      )}

      
      

     
{/* 
      <Tooltip title="Filter Panel" placement="left">
        <IconButton
          onClick={() => setShowFilters(!showFilters)}
          sx={{
            color: "#ffffff",
            position: "fixed",  // Absolutely position it within the parent box
            top: "70px",            // Add some spacing from the top
            right: "10px",          // Add some spacing from the right edge
            zIndex: 20,
            "&:hover": {
              color: "#1E90FF",  // Icon color on hover
            },
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Tooltip> */}

      {showFilters && (
        <Box sx={{
          position: "fixed",
          top: "60px",
          right: "0",
          width: "300px",
          height: "100%",
          backgroundColor: "#000000",
          padding: "1rem",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          borderRadius: "8px",
          zIndex: "10",

        }}>


          {/* <FormControl sx={{ width: "100%", marginBottom: "1rem", marginTop: "2rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Rating</InputLabel>
            <Select
              value={filters.rating}
              label="Rating"
              onChange={(e) => handleFilterChange(e, "rating")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              {[0, 1, 2, 3, 4, 5].map((rating) => (
                <MenuItem key={rating} value={rating} sx={{ letterSpacing: 2, }}>
                  {rating}+
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: "1rem",
                flexWrap: "wrap",
              }}
            >
              <TextField
                type="date"
                value={tempDate}
                onChange={(e) => setTempDate(e.target.value)}
                sx={{
                  backgroundColor: "#2222",
                  color: "#ffffff",
                  letterSpacing: 2,
                  "& .MuiInputBase-root": {
                    color: "#ffffff",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#2222",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#1E90FF",
                  },
                  flexGrow: 1,
                }}
              />
              <Button
                variant="contained"
                onClick={() => {
                  setFilters((prev) => ({
                    ...prev,
                    date: tempDate,
                  }));
                }}
              >
                Apply
              </Button>
            </Box>


          </Box>
          {/* Language Filter */}
          <FormControl sx={{ width: "100%", marginBottom: "1rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Language</InputLabel>
            <Select
              value={filters.language}
              label="Language"
              onChange={(e) => handleFilterChange(e, "language")}
              sx={{
                backgroundColor: "#2222",
                letterSpacing: 2,
                color: "#ffffff",
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              <MenuItem value="" sx={{ letterSpacing: 2, }}>Select Language</MenuItem>
              {languages.map((lang, index) => (
                <MenuItem key={index} value={lang} sx={{ letterSpacing: 2, }}>
                  {lang}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ width: "100%", marginBottom: "1rem" }}>
            <Typography gutterBottom sx={{ color: "#ffffff", letterSpacing: 2, }}>Duration</Typography>
            <Slider
              value={filters.duration}
              onChange={(e, newValue) => handleSliderChange(e, newValue, "duration")}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `${value} mins`}
              min={0}
              max={120}
              step={10}
              sx={{
                color: "#1E90FF",
                letterSpacing: 2,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#1E90FF",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#555555",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1E90FF",
                }
              }}
            />
          </Box>
          {/* Cost Filter */}
          <Box sx={{ width: "100%", marginBottom: "1rem" }}>
            <Typography gutterBottom sx={{ color: "#ffffff", letterSpacing: 2, }}>Cost</Typography>
            <Slider
              value={filters.cost}
              onChange={(e, newValue) => handleSliderChange(e, newValue, "cost")}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `₹ ${value}`}
              min={0}
              max={10000}
              step={10}
              sx={{
                color: "#1E90FF",
                letterSpacing: 2,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#1E90FF",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#555555",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1E90FF",
                }
              }}
            />
          </Box>

          <Box sx={{}}>
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              sx={{
                width: "100%",
                color: "#1E90FF",
                letterSpacing: 2,
                borderColor: "#1E90FF",
                "&:hover": {
                  backgroundColor: "#1E90FF",
                  color: "#fff"
                }
              }}
            >
              Clear Filters
            </Button>
          </Box>

        </Box>
      )}
    

      {/* <Box sx={{ textAlign: 'center', mt:3 }}>
    <Typography
      variant="h6"
      sx={{
        color: '#ffffff',
        letterSpacing: 1.2,
        fontWeight: 500,
      }}
    >
      Showing {allCards.length} Real-Time Session{allCards.length !== 1 ? 's' : ''}
    </Typography>
  </Box> */}

  <NeonSpeedometer value={allCards.length} />

      {/* Filter Bar */}
      <Box sx={{ marginRight: showFilters ? "75px" : "0", transition: "margin-right 0.3s", mt: 10 }}>
          {/* Add post count here */}
  

  {showScrollMessage && (
  <Box
  sx={{
    position: 'fixed',
    bottom: 80,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '0.95rem',
    boxShadow: '0 2px 12px rgba(0,0,0,0.4)',
    zIndex: 1500,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  }}
>
  <span>Scroll down to load more...</span>
  <ArrowDownwardIcon fontSize="small" />
</Box>
)}

        {/* Cards Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            mt: 4,
          }}
        >
          {allCards.map((card, index) => {
            const isBundle = card.is_bundle;
            const profileName = `${card.teacher} ${card.surname}`;
            const truncatedName =
              profileName.length > 40 ? profileName.slice(0, 40) + '...' : profileName;

            const destinationPath = isBundle
              ? `/bundle-detail/${card.id}`
              : `/post-tab-details/${card.id}`;

            const fullPathWithQuery = `${destinationPath}?isBundle=${isBundle}`;

            // You should have `isLoggedIn` available from context, props, or global state
            const linkTo = loggedIn
              ? fullPathWithQuery
              : `/login?redirect=${encodeURIComponent(fullPathWithQuery)}`;

            return (
              <Tooltip title="Click to View" placement="top">
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '20px',
          width: { xs: '92%', sm: '75%', md: '60%', lg: '50%', xl: '40%' },
          mb: 4,
          background: isBundle ? 'linear-gradient(135deg, #0f2027, #080a0aff, #0d0f0fff)' : 'rgba(255, 255, 255, 0.03)',
          border: isBundle ? '2px solid #224b50ff' : '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: isBundle ? '0 15px 40px rgba(43, 70, 70, 0.2)' : '0 10px 30px rgba(0,0,0,0.25)',
          backdropFilter: 'blur(16px)',
          transition: 'all 0.4s ease-in-out',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 25px 60px rgba(0,0,0,0.4)',
            borderImage: !isBundle ? 'linear-gradient(45deg, #2196F3, #E040FB) 1' : 'none',
          },
        }}
      >
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: '20px' }} />
        ) : (
          <Link to={linkTo} style={{ textDecoration: 'none', color: 'inherit' }}>
            {/* Media */}
            <Box sx={{ position: 'relative' }}>
              {card.media_url ? (
                card.media_type === 'video' ? (
                  <Box
                    component="video"
                    src={card.media_url}
                    controls={!isBundle}
                    autoPlay={false}
                    muted
                    sx={{ width: '100%', height: 'auto', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', objectFit: 'cover' }}
                  />
                ) : (
                  <Box
                    component="img"
                    src={card.media_url}
                    alt="media"
                    sx={{ width: '100%', height: 'auto', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', objectFit: 'cover' }}
                  />
                )
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: 200,
                    borderTopLeftRadius: '20px',
                    borderTopRightRadius: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f0f0',
                    color: '#888',
                  }}
                >
                  No media uploaded
                </Box>
              )}

              {/* Bundle Badge */}
              {isBundle && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 12,
                    left: 12,
                    background: 'rgba(0, 0, 0, 1)',
                    border: '1px solid #1E90FF',
                    px: 2,
                    py: 0.5,
                    borderRadius: '8px',
                    fontSize: '0.75rem',
                    color: '#1E90FF',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    backdropFilter: 'blur(6px)',
                  }}
                >
                  Series
                </Box>
              )}
            </Box>

            {/* Share Button */}
            <Box sx={{ position: 'absolute', bottom: 100, right: 1, zIndex: 1 }}>
              <ShareButton postUrl={`${window.location.origin}/share/${card.is_bundle ? "bundle" : "post"}/${card.id}`} />
            </Box>

            {/* Highlighted Topic */}
            <Typography
              variant="body2"
              sx={{ color: '#bbb', mt: 2, px: 3, fontSize: '1rem', fontStyle: 'italic', lineHeight: 1.5 }}
            >
              {card?.highlightedTopic?.length > 100 ? `${card.highlightedTopic.slice(0, 100)}...` : card?.highlightedTopic || ''}
            </Typography>

            {/* Avatar & Name */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 3, mt: 3 }}>
              {loading ? (
                <Skeleton variant="circular" width={50} height={50} />
              ) : (
                <Avatar sx={{ width: 50, height: 50, bgcolor: '#0a2e57ff', fontSize: 28 }} src={card.image || undefined}>
                  {!card.image && card.name ? card.name.charAt(0).toUpperCase() : null}
                </Avatar>
              )}
              {loading ? <Skeleton width={100} height={30} /> : (
                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem', color: 'white' }}>
                  {truncatedName}
                </Typography>
              )}
            </Box>

            {/* Extra Info */}
            {loading ? (
              <Stack direction="row" spacing={1} sx={{ mt: 3, px: 3 }}>
                <Skeleton width={80} height={30} />
                <Skeleton width={60} height={30} />
                <Skeleton width={50} height={30} />
              </Stack>
            ) : (
              <Grid container spacing={2} justifyContent="flex-start" alignItems="center" sx={{ mt: 3, px: 3, rowGap: 2 }}>
                <Grid item>
                  <Typography sx={{
                    display: 'inline-flex', alignItems: 'center', gap: 1,
                    fontWeight: '600', fontSize: '1rem', color: '#ffffff',
                    background: 'linear-gradient(135deg, #2079c2ff 0%, #1f2c33ff 100%)',
                    px: 2, py: 0.5, borderRadius: '18px', boxShadow: '0 2px 10px rgba(48, 71, 83, 0.4)',
                    whiteSpace: 'nowrap', textShadow: '0 1px 2px rgba(0,0,0,0.4)', letterSpacing: 0.4,
                    userSelect: 'none', width: 'fit-content', cursor: 'default',
                  }}>
                    🗓 {formatTimeToAMPM(card.starttime)} • {formatDateWithSuffix(card.date)}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography sx={{
                    display: 'inline-flex', alignItems: 'center', gap: 1,
                    fontWeight: '600', fontSize: '1rem', color: '#ffffff',
                    background: 'linear-gradient(135deg, #c78b1cff, #27231aff)',
                    px: 2, py: 0.5, borderRadius: '20px', boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                    letterSpacing: 0.3, whiteSpace: 'nowrap', textShadow: '0 0 4px rgba(0,0,0,0.25)',
                    userSelect: 'none', cursor: 'default', width: 'fit-content',
                  }}>
                    🗣 {card.language}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography sx={{
                    display: 'inline-flex', alignItems: 'center', gap: 1,
                    fontWeight: '600', fontSize: '1rem', color: '#ffffff',
                    background: 'linear-gradient(135deg, #bcc71cff, #27231aff)',
                    px: 2, py: 0.5, borderRadius: '20px', boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                    letterSpacing: 0.3, whiteSpace: 'nowrap', textShadow: '0 0 4px rgba(0,0,0,0.25)',
                    userSelect: 'none', cursor: 'default', width: 'fit-content',
                  }}>
                    ₹{card.price}
                  </Typography>
                </Grid>
              </Grid>
            )}

            {/* Call to Action */}
            <Box sx={{ textAlign: 'center', mt: 4, pb: 3 }}>
              <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                {loading ? (
                  <>
                    <Skeleton variant="rectangular" width={120} height={40} />
                    <Skeleton variant="rectangular" width={120} height={40} />
                  </>
                ) : (
                  <>
                    {userId && <ReserveButton postId={card.id} />}
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: '1rem',
                        padding: '12px 28px',
                        borderRadius: '10px',
                        backgroundImage: isBundle
                          ? 'linear-gradient(to right, #17c9ddff, #397a8bff)'
                          : 'linear-gradient(to right, #7b1fa2, #512da8)',
                        color: '#fff',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'scale(1.05)',
                          backgroundImage: isBundle
                            ? 'linear-gradient(to right, #1babd3ff, #307e86ff)'
                            : 'linear-gradient(to right, #512da8, #7b1fa2)',
                        },
                      }}
                    >
                      {isBundle ? 'View Series' : 'Book Now'}
                    </Button>
                  </>
                )}
              </Stack>
            </Box>
          </Link>
        )}
      </Box>
    </Tooltip>
              
            );
          })}
        </Box>
        {loading && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 2000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(3px)',
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <CircularProgress
                size={60}
                thickness={6}
                sx={{
                  color: 'transparent',
                  '& .MuiCircularProgress-circle': {
                    stroke: 'url(#better-gradient)',
                  },
                }}
              />

              <svg width="0" height="0">
                <defs>
                  <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                    <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                    <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                  </linearGradient>
                </defs>
              </svg>

              <Typography
                variant="h6"
                sx={{
                  mt: 2,
                  color: '#fff',
                  textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                }}
              >
                Loading Sessions... ({loadingSeconds} sec)
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      
      {/* Popup Dialog */}
      <Dialog
        open={open}
        onClose={handleSkip}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            p: 1,
            background: "rgba(20, 20, 20, 0.8)",
            backdropFilter: "blur(12px)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)",
            animation: "fadeIn 0.4s ease",
          },
        }}
      >
        {/* ---- Dark Gradient Header ---- */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #1e1e1e, #0d0d0d)",
            color: "white",
            borderRadius: "12px 12px 0 0",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid rgba(255,255,255,0.1)"
          }}
        >
          <Box
  sx={{
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
  }}
>
  <AutoAwesomeIcon sx={{ color: "#bb86fc" }} />
  <Typography variant="h6" fontWeight="bold">
    AI Training & Internship Program
  </Typography>
</Box>


          <IconButton onClick={handleSkip} sx={{ color: "#bbb" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* ---- Body ---- */}
        <DialogContent
          sx={{
            mt: 2,
            textAlign: "center",
            px: 4,
            color: "#ddd",
          }}
        >
          <Typography sx={{ fontSize: "1.1rem", mb: 3 }}>
            Discover our future-ready AI Training and Internship Program built for modern
            innovators. Click <strong>Open</strong> to explore the details.
          </Typography>

          {/* Neon glowing icon */}
          <AutoAwesomeIcon
            sx={{
              fontSize: 55,
              color: "#bb86fc",
              filter: "drop-shadow(0px 0px 12px rgba(187, 134, 252, 0.7))",
              mb: 2,
            }}
          />
        </DialogContent>

        {/* ---- Actions ---- */}
        <DialogActions
          sx={{
            px: 4,
            pb: 3,
            display: "flex",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #8f57ff, #6a3ddb)",
              color: "white",
              px: 4,
              py: 1,
              borderRadius: 3,
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": {
                background: "linear-gradient(135deg, #7b48db, #542fb1)",
              },
            }}
            onClick={handleOpenLink}
          >
            Open
          </Button>

          <Button
            variant="outlined"
            sx={{
              borderRadius: 3,
              px: 4,
              py: 1,
              textTransform: "none",
              fontSize: "1rem",
              borderColor: "rgba(255,255,255,0.3)",
              color: "rgba(255,255,255,0.7)",
              "&:hover": {
                borderColor: "rgba(255,255,255,0.6)",
                background: "rgba(255,255,255,0.05)",
              },
            }}
            onClick={handleSkip}
          >
            Skip
          </Button>
        </DialogActions>
      </Dialog>

    </Box >
    <Tooltip title="Scroll to Top" placement="top">
          
                  <IconButton
                    onClick={scrollToTop}
                    sx={{
                      position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black', "&:hover": {
                        color: "#1E90FF",  // Icon color on hover
                      },
                    }}
                  >
                    <ArrowUpwardIcon />
                  </IconButton>
                </Tooltip>
    <Footer2/>
    </div>
  );
}
export default Posted;